<template>
  <!-- 修改用户名称弹窗 -->
  <el-dialog
    title="修改用户名称"
    :visible.sync="visible"
    width="420px"
    @close="close"
  >
    <el-form :model="form" label-width="80px" ref="formRef">
      <el-form-item label="当前名称">
        <span style="font-size: 14px; color: #666;">{{ userName }}</span>
      </el-form-item>

      <el-form-item label="新名称" prop="newName">
        <el-input
          v-model="form.newName"
          placeholder="请输入新的用户名称"
          maxlength="20"
          show-word-limit
        />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="submit">确认修改</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'changeText',
  props: {
    show: { type: Boolean, default: false },
    userName: { type: String, default: '' } // 当前名称
  },
  data() {
    return {
      form: {
        newName: ''
      }
    }
  },
  computed: {
    visible: {
      get() { return this.show },
      set(val) { this.$emit('update:show', val) }
    }
  },
  methods: {
    close() {
      this.form.newName = ''
      this.$emit('update:show', false)
    },
    // 提交修改
    submit() {
      const { newName } = this.form
      if (!newName || newName.trim() === '') {
        this.$message.error('请输入新名称')
        return
      }
	let userType = localStorage.getItem('userType')
	 const userId = localStorage.getItem('userId')
      // 调用接口PutSchoolText
	  console.log('userType',userType)
	  if(userType==1){
		  this.API.put(this.API.admin.PutAdminText,  {
		   name:newName,
		   id:userId
		  }).then(res => {
		    if (res.data.code === 200) {
		      this.$message.success('修改成功')
		  		  localStorage.setItem('nickName',newName)
		      // 通知父组件刷新名称
		      this.$emit('success')
		      this.close()
		    } else {
		      this.$message.error(res.data.msg)
		    }
		  }).catch(() => {
		    this.$message.error('修改失败')
		  })
	  }
	  if(userType==2){
	  		  this.API.put(this.API.school.PutSchoolText,  {
	  		   name:newName,
	  		   id:userId
	  		  }).then(res => {
	  		    if (res.data.code === 200) {
	  		      this.$message.success('修改成功')
	  		  		  localStorage.setItem('nickName',newName)
	  		      // 通知父组件刷新名称
	  		      this.$emit('success')
	  		      this.close()
	  		    } else {
	  		      this.$message.error(res.data.msg)
	  		    }
	  		  }).catch(() => {
	  		    this.$message.error('修改失败')
	  		  })
	  }
	  
     
    }
  }
}
</script>